import { MdKeyboardDoubleArrowDown, MdKeyboardDoubleArrowRight, MdHighlightOff } from "react-icons/md";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal, ModalOverlay } from "@chakra-ui/modal";
import Searchbox from "components/fields/Searchbox";
import { getImage } from "utils/commonFunction";
import { convertToFloat } from "utils/formatNumber";
import { BsArrowDown, BsArrowUp, BsReceipt, BsXCircleFill } from "react-icons/bs";
import Pagination from "components/pagination";
import ShortTruncateCopy from "components/common/ShortTruncateCopy";
import StatusRender from "../../payments/components/StatusRender";
import StatusStyle from "./StatusStyle";
import { SubscriptionObj } from "..";
import RefundModal from "../../payments/components/RefundModal";
import InfoModal from "../../payments/components/InfoModal";
import toast from "react-hot-toast";
import { useTable, useSortBy, useExpanded, Column, Row } from "react-table";
import RetryModal from "../../payments/components/RetryModal";
import visa from "assets/svg/card_type/visa.svg";
import MasterCard from "assets/svg/card_type/mastercard.svg";
import Discover from "assets/svg/card_type/discover.svg";
import Amex from "assets/svg/card_type/amex.svg";
import MaestroCard from "assets/svg/card_type/maestro.svg";
import DinersClub from "assets/svg/card_type/dinersclub.svg";
import JCB from "assets/svg/card_type/jcb.svg";
import UnionPay from "assets/svg/card_type/unionpay.svg";
import DivLoader from "components/divloader/DivLoader";
import FilterModal from "./FilterModal";
import InfoModalSubscription from "./InfoModalSubscription";
import { FaDownload } from "react-icons/fa";
import { DownloadCSV, subscriptionGetClients } from "api/subscription";
import { cancelSubscription } from "api/graphQL_subscriptions";
import lightningChecksLogo from "../../../../assets/img/mainlogo.png";
import bm2bankLogo from "../../../../assets/img/paxum.svg";
import bm2payLogo from "../../../../assets/img/bm2pay.svg";
import { RiArrowUpDownFill } from "react-icons/ri";
import { Popover, PopoverTrigger, PopoverContent, PopoverHeader, PopoverArrow } from "@chakra-ui/react";

const CancelSubscriptionPanel = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  subscriptionId,
  clientName,
  amount,
  currency,
  interval,
}: {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
  subscriptionId?: string;
  clientName?: string;
  amount?: number | string;
  currency?: string;
  interval?: string;
}) => {
  const [isCloseModal, setIsCloseModal] = React.useState(false);
  const [confirmed, setConfirmed] = React.useState(false);

  const handleClose = () => {
    setIsCloseModal(true);
    setConfirmed(false);
    setTimeout(() => { setIsCloseModal(false); onClose(); }, 320);
  };

  useEffect(() => { if (!isOpen) setConfirmed(false); }, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <ModalOverlay bg="rgba(15,23,42,0.55)" backdropFilter="blur(4px)" />

      <div className={`csp-panel${isOpen && !isCloseModal ? " csp-panel--open" : " csp-panel--close"}`}>

        {/* Animated top glow */}
        <div className="csp-glow" />

        {/* Header */}
        <div className="csp-header">
          <div className="csp-header-left">
            <div className="csp-header-icon">
              <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
              </svg>
            </div>
            <div>
              <h2 className="csp-header-title">Cancel Subscription</h2>
              <p className="csp-header-sub">This action will stop future billing</p>
            </div>
          </div>
          <button className="csp-close-btn" onClick={handleClose} aria-label="Close">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="csp-body">

          {/* Subscription summary card */}
          {(clientName || subscriptionId) && (
            <div className="csp-summary-card">
              <p className="csp-summary-label">Subscription details</p>
              <div className="csp-summary-rows">
                {clientName && (
                  <div className="csp-summary-row">
                    <span className="csp-summary-key">Client</span>
                    <div className="csp-summary-val-wrap">
                      <div className="csp-client-avatar">{clientName?.charAt(0)?.toUpperCase()}</div>
                      <span className="csp-summary-val">{clientName}</span>
                    </div>
                  </div>
                )}
                {subscriptionId && (
                  <div className="csp-summary-row">
                    <span className="csp-summary-key">Subscription ID</span>
                    <code className="csp-summary-code">{subscriptionId?.slice(0, 20)}{subscriptionId?.length > 20 ? "…" : ""}</code>
                  </div>
                )}
                {amount && (
                  <div className="csp-summary-row">
                    <span className="csp-summary-key">Amount</span>
                    <span className="csp-summary-val csp-summary-val--bold">{amount} {currency}</span>
                  </div>
                )}
                {interval && (
                  <div className="csp-summary-row">
                    <span className="csp-summary-key">Interval</span>
                    <span className="csp-interval-tag">{interval}</span>
                  </div>
                )}
              </div>
            </div>
          )}

          {/* Warning card */}
          <div className="csp-warning-card">
            <div className="csp-warning-icon-wrap">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                <line x1="12" y1="9" x2="12" y2="13"/>
                <line x1="12" y1="17" x2="12.01" y2="17"/>
              </svg>
            </div>
            <div className="csp-warning-content">
              <p className="csp-warning-title">Are you sure you want to cancel?</p>
              <p className="csp-warning-desc">
                Cancelling this subscription will immediately stop all future payments. This action cannot be undone.
              </p>
            </div>
          </div>

          {/* What happens list */}
          <div className="csp-consequences">
            <p className="csp-consequences-title">What will happen:</p>
            <div className="csp-consequence-list">
              {[
                "All scheduled future payments will be stopped",
                "The subscription status will change to CANCELLED",
                "No further billing cycles will be processed",
                "Existing completed payments will not be refunded",
              ].map((item, i) => (
                <div key={i} className="csp-consequence-item">
                  <div className="csp-consequence-dot" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Info tip */}
          <div className="csp-tip">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <span>Contact support if you need to issue a refund for past payments.</span>
          </div>

          {/* Confirm checkbox — same pattern as DeleteOrgModal */}
          <label className="csp-confirm-row">
            <input
              type="checkbox"
              className="csp-confirm-check"
              checked={confirmed}
              onChange={(e) => setConfirmed(e.target.checked)}
            />
            <span className="csp-confirm-label">
              I understand this subscription will be permanently cancelled and future payments stopped
            </span>
          </label>

        </div>

        {/* Footer */}
        <div className="csp-footer">
          <div className="csp-footer-note">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            Confirm your intent before proceeding
          </div>
          <div className="csp-footer-btns">
            <button className="csp-btn-cancel" onClick={handleClose}>Keep Active</button>
            <button
              className={`csp-btn-confirm${confirmed ? "" : " csp-btn-confirm--disabled"}`}
              onClick={onConfirm}
              disabled={!confirmed || isLoading}
            >
              {isLoading ? (
                <span className="csp-spinner" />
              ) : (
                <>
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="10"/>
                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"/>
                  </svg>
                  Cancel Subscription
                </>
              )}
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .csp-panel {
          font-family: 'Plus Jakarta Sans', sans-serif;
          position: fixed; top: 0; right: 0; bottom: 0;
          width: 100%; max-width: 620px;
          background: #fff; z-index: 1004;
          display: flex; flex-direction: column;
          box-shadow: -8px 0 40px rgba(15,23,42,.15);
          transition: transform .32s cubic-bezier(0.16,1,0.3,1);
          overflow: hidden;
        }
        .csp-panel--open  { transform: translateX(0); }
        .csp-panel--close { transform: translateX(100%); }

        .csp-glow {
          height: 3px; flex-shrink: 0;
          background: linear-gradient(90deg,#7f1d1d,#dc2626,#ef4444,#dc2626,#7f1d1d);
          background-size: 200% 100%;
          animation: cspGlow 3s linear infinite;
        }
        @keyframes cspGlow { 0%{background-position:0%} 100%{background-position:200%} }

        .csp-header {
          padding: 15px 26px;
          background: linear-gradient(135deg, #7f1d1d 0%, #b91c1c 60%, #dc2626 100%);
          display: flex; align-items: center; justify-content: space-between; flex-shrink: 0;
        }
        .csp-header-left { display: flex; align-items: center; gap: 14px; }
        .csp-header-icon {
          width: 42px; height: 42px; border-radius: 11px;
          background: rgba(255,255,255,.18); border: 1.5px solid rgba(255,255,255,.28);
          display: flex; align-items: center; justify-content: center;
          color: #fff; flex-shrink: 0;
        }
        .csp-header-title { font-size: 16px; font-weight: 800; color: #fff; letter-spacing: -.3px; margin-bottom: 2px; line-height: 22px; }
        .csp-header-sub { font-size: 12.5px; color: rgba(255,255,255,.65); font-weight: 500; }
        .csp-close-btn {
          background: rgba(255,255,255,.15); border: none; border-radius: 8px;
          width: 32px; height: 32px; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: rgba(255,255,255,.8); transition: background .15s;
        }
        .csp-close-btn:hover { background: rgba(255,255,255,.25); color: #fff; }

        .csp-body { flex: 1; padding: 22px 26px; display: flex; flex-direction: column; gap: 16px; overflow-y: auto; }
        .csp-body::-webkit-scrollbar { width: 4px; }
        .csp-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        /* Summary card */
        .csp-summary-card { background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 13px; padding: 16px; }
        .csp-summary-label { font-size: 11px; font-weight: 700; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }
        .csp-summary-rows { display: flex; flex-direction: column; gap: 10px; }
        .csp-summary-row { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
        .csp-summary-key { font-size: 12px; font-weight: 600; color: #64748b; flex-shrink: 0; }
        .csp-summary-val-wrap { display: flex; align-items: center; gap: 7px; }
        .csp-client-avatar { width: 22px; height: 22px; border-radius: 6px; background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; font-size: 9px; font-weight: 800; color: #2563eb; flex-shrink: 0; }
        .csp-summary-val { font-size: 13px; font-weight: 600; color: #0f172a; }
        .csp-summary-val--bold { font-weight: 700; }
        .csp-summary-code { font-family: 'Courier New', monospace; font-size: 12px; color: #334155; font-weight: 600; background: #fff; border: 1px solid #e2e8f0; border-radius: 6px; padding: 2px 8px; letter-spacing: .3px; }
        .csp-interval-tag { display: inline-block; padding: 3px 9px; border-radius: 7px; font-size: 11px; font-weight: 700; background: #f0f9ff; border: 1.5px solid #bae6fd; color: #0284c7; text-transform: uppercase; }

        /* Warning card */
        .csp-warning-card {
          display: flex; gap: 14px;
          background: linear-gradient(135deg,#fff7f7,#fee2e2);
          border: 1.5px solid #fecaca; border-radius: 14px; padding: 16px;
        }
        .csp-warning-icon-wrap { width: 44px; height: 44px; border-radius: 11px; background: #fff; border: 1.5px solid #fecaca; display: flex; align-items: center; justify-content: center; color: #dc2626; flex-shrink: 0; }
        .csp-warning-content { flex: 1; }
        .csp-warning-title { font-size: 14px; font-weight: 700; color: #991b1b; margin-bottom: 6px; line-height: 1.2; }
        .csp-warning-desc { font-size: 13px; color: #b91c1c; line-height: 1.6; font-weight: 500; }

        /* Consequences */
        .csp-consequences { background: #fafbfc; border: 1px solid #e2e8f0; border-radius: 12px; padding: 15px; }
        .csp-consequences-title { font-size: 11.5px; font-weight: 700; color: #374151; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 11px; }
        .csp-consequence-list { display: flex; flex-direction: column; gap: 8px; }
        .csp-consequence-item { display: flex; align-items: center; gap: 10px; font-size: 13px; color: #475569; font-weight: 500; line-height: 1.4; }
        .csp-consequence-dot { width: 6px; height: 6px; border-radius: 50%; background: #ef4444; flex-shrink: 0; }

        /* Tip */
        .csp-tip { display: flex; align-items: flex-start; gap: 9px; background: #eff6ff; border: 1.5px solid #bfdbfe; border-radius: 10px; padding: 12px 14px; font-size: 12.5px; color: #1d4ed8; font-weight: 500; line-height: 1.5; }
        .csp-tip svg { flex-shrink: 0; margin-top: 1px; color: #2563eb; }

        /* Confirm checkbox */
        .csp-confirm-row { display: flex; align-items: flex-start; gap: 12px; cursor: pointer; background: #fffbeb; border: 1.5px solid #fde68a; border-radius: 12px; padding: 14px; }
        .csp-confirm-check { width: 18px; height: 18px; flex-shrink: 0; margin-top: 2px; accent-color: #dc2626; cursor: pointer; }
        .csp-confirm-label { font-size: 13px; font-weight: 600; color: #92400e; line-height: 1.55; }

        /* Footer */
        .csp-footer { padding: 14px 26px; border-top: 1px solid #f1f5f9; background: #fafbfc; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; flex-shrink: 0; }
        .csp-footer-note { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #94a3b8; font-weight: 500; }
        .csp-footer-btns { display: flex; gap: 10px; }

        .csp-btn-cancel { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 600; color: #64748b; padding: 10px 20px; border-radius: 10px; border: 1.5px solid #e2e8f0; background: #fff; cursor: pointer; transition: all .15s; }
        .csp-btn-cancel:hover { background: #f1f5f9; border-color: #cbd5e1; }

        .csp-btn-confirm {
          display: inline-flex; align-items: center; gap: 7px;
          font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13.5px; font-weight: 700; color: #fff;
          padding: 10px 20px; border-radius: 10px; border: none;
          background: linear-gradient(135deg, #991b1b, #dc2626);
          cursor: pointer; box-shadow: 0 4px 14px rgba(220,38,38,.28);
          transition: transform .15s, box-shadow .18s;
        }
        .csp-btn-confirm:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(220,38,38,.36); }
        .csp-btn-confirm--disabled { opacity: .42; cursor: not-allowed; transform: none !important; box-shadow: none !important; }

        .csp-spinner { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,.35); border-top-color: #fff; border-radius: 50%; animation: cspSpin .65s linear infinite; }
        @keyframes cspSpin { to { transform: rotate(360deg); } }

        @media (max-width: 540px) {
          .csp-panel { max-width: 100%; }
          .csp-header, .csp-body, .csp-footer { padding-left: 18px; padding-right: 18px; }
        }
      `}</style>
    </Modal>
  );
};

let MainManagedBy: string = 'Bm2pay';
let mainlogo: string = bm2payLogo;
if (window.location.hostname === "gateway-dev.lightningchecks.com" || window.location.hostname === "gateway.lightningchecks.com" || window.location.hostname === "testing.lightningchecks.com") {
  MainManagedBy = 'LIGHTNI CHECKS'; mainlogo = lightningChecksLogo;
} else if (window.location.hostname === "gateway-dev.bm2pay.com" || window.location.hostname === "gateway.bm2pay.com") {
  MainManagedBy = 'Bm2pay'; mainlogo = bm2payLogo;
} else if (window.location.hostname === "pay.paxum.com") {
  MainManagedBy = 'PAXUM'; mainlogo = bm2bankLogo;
} else if (window.location.hostname === "gateway-stagging.bm2pay.com") {
  MainManagedBy = 'Bm2pay'; mainlogo = bm2payLogo;
}

export type Payment = {
  id: string; payment_id: string; et_id: string; amount: number;
  currency: string; gateway_id: string; gateway_hash: string; gateway_name: string;
  status: string; meta_info: string; payment_type: string; client: string;
  card_type: string; descriptor: string; refund_info: string; image: string;
  receipt_url: string; created_at: any; next_payment_date: any;
};

const CARD_SVGS: Record<string, string> = { visa, VISA: visa, MasterCard, Discover, Amex, MaestroCard, DinersClub, JCB, UnionPay };
const getCardSVG = (type: string) => {
  const src = CARD_SVGS[type];
  if (!src) return <span className="sub-muted">—</span>;
  return <img style={{ maxWidth: "52px", height: "auto" }} src={src} alt={type} title={type} />;
};

function SubscriptionList(props: {
  data: SubscriptionObj[]; isLoading: boolean; roleData: any;
  page: number; setPage: any; totalpage: number; totalItems: number;
  currentPage: number; pageSize: number; setPageSize: any; allGateways: any;
  fetchSubscriptions: any; setClearClick: () => void;
  onValueChange: (value: string) => void; filterData: () => void;
  filter: any; setFilter: (value: any) => void;
  setStatusChanged: (value: any) => void; setIsLoading: (value: any) => void;searchTexts:any
}) {
  const {
    data, pageSize, setPageSize, page, setPage, totalpage, currentPage,
    onValueChange, roleData, allGateways, fetchSubscriptions, setFilter,
    setClearClick, setStatusChanged, setIsLoading, filter, filterData,searchTexts
  } = props;

  const [expandedRows, setExpandedRows] = useState<Record<string, boolean>>({});
  const [subClientsData, setSubClientsData] = useState([]);
  const [DownloadLoading, setDownloadLoading] = useState(false);
  // const [popoverOpen, setPopoverOpen] = useState(false);

  // Cancel subscription panel state
  const [cancelPanelOpen, setCancelPanelOpen] = useState(false);
  const [cancelPanelLoading, setCancelPanelLoading] = useState(false);
  const [cancelTarget, setCancelTarget] = useState<{
    subscriptionId: string; clientId: string; clientSecret: string;
    clientName: string; amount: any; currency: string; interval: string;
  } | null>(null);

  const method = roleData[0]?.subscription?.value?.subscription_show_method_name;

  const deleteSubscription = useCallback(async (id: any, client_id: any, client_secret: any) => {
    cancelSubscription({ subscription_id: id }, client_id, client_secret)
      .then((response) => {
        if (response.status) {
          if (response.status === 'false' || response.status === null || response.status === "") {
            toast.error(response.message);
          } else {
            setIsLoading(true);
            toast.success("Subscription Cancelled Successfully");
            setStatusChanged(true);
            setTimeout(() => setIsLoading(false), 2000);
          }
        } else {
          toast.error(response.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while cancelling subscription"));
  }, [setIsLoading, setStatusChanged]);

  const openCancelPanel = useCallback((row: any) => {
    setCancelTarget({
      subscriptionId: row.subscription_id,
      clientId: row.client_id,
      clientSecret: row.client_secret,
      clientName: row.client,
      amount: row.amount,
      currency: row.currency,
      interval: row.interval,
    });
    setCancelPanelOpen(true);
  }, []);

  const handleCancelConfirm = () => {
    if (!cancelTarget) return;
    setCancelPanelLoading(true);
    cancelSubscription({ subscription_id: cancelTarget.subscriptionId }, cancelTarget.clientId, cancelTarget.clientSecret)
      .then((response) => {
        if (response.status && response.status !== 'false' && response.status !== null && response.status !== "") {
          setIsLoading(true);
          toast.success("Subscription Cancelled Successfully");
          setStatusChanged(true);
          setCancelPanelOpen(false);
          setCancelTarget(null);
          setTimeout(() => setIsLoading(false), 2000);
        } else {
          toast.error(response.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message ?? "Something went wrong while cancelling subscription"))
      .finally(() => setCancelPanelLoading(false));
  };
  
  const getGatewayId = (name: any) => {
    if (!allGateways?.length) return "Unknown";
    const gw = allGateways.find((item: any) => item.name?.trim().toLowerCase() === name?.trim().toLowerCase());
    return gw ? gw.id : "Unknown";
  };

  const canCancelSubscription =
    roleData?.[0]?.subscription?.value?.cancel_subscription;

  const canViewSubscriptionInfo =
    roleData?.[0]?.subscription?.value?.view_subscription_response_information ||
    roleData?.[0]?.subscription?.value?.view_subscription_gateway_response_information;

  const columns: Column<SubscriptionObj>[] = useMemo(() => [
    {
      Header: "", accessor: "subscription_id",
      Cell: ({ row }: any) => (
        <button
          className="sub-expand-btn"
          onClick={() => setExpandedRows((prev) => ({ [row.id]: !prev[row.id] }))}
          aria-label="Expand row"
        >
          {expandedRows[row.id]
            ? <MdKeyboardDoubleArrowDown className="sub-expand-icon" />
            : <MdKeyboardDoubleArrowRight className="sub-expand-icon" />}
        </button>
      ),
      disableSortBy: true,
    },
    {
      Header: "Client", accessor: "client",
      sortType: (a, b) => {
        const result = (a.original.client || "").localeCompare(b.original.client || "");
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => (
        <div className="sub-client-cell">
          <div className="sub-client-avatar">{value?.charAt(0)?.toUpperCase() || "?"}</div>
          <span className="sub-client-name">{value}</span>
        </div>
      ),
    },
    {
      Header: "Managed By", accessor: "managed_by",
      sortType: (a, b) => {
        const gwA = a.original.subscription_provider_name || "";
        const gwB = b.original.subscription_provider_name || "";
        const result = gwA.localeCompare(gwB);
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ row }: any) => {
        const gwName = row?.original?.subscription_provider_name;
        return (
          <div className="sub-gateway-cell">
            {row.original?.managed_by === 1 ? (
              gwName === null ? (
                row.original?.subscription_provider !== null
                  ? <ShortTruncateCopy info={row.original?.subscription_provider || "—"} showCopy />
                  : <span className="sub-muted">—</span>
              ) : !method
                ? <ShortTruncateCopy info={getGatewayId(gwName)} showCopy />
                : <><img style={{ height: "auto", width: "14px" }} src={getImage(gwName)} alt={gwName} /><span className="sub-gateway-name">{gwName || "—"}</span></>
            ) : (
              <><img style={{ height: "auto", width: "14px" }} src={mainlogo} alt={MainManagedBy} /><span className="sub-gateway-name">{MainManagedBy}</span></>
            )}
          </div>
        );
      },
    },
    { 
      Header: "Start Date", 
      accessor: "start_date", 
      sortType: (a, b) => {
        const d1 = new Date(a.original.start_date).getTime();
        const d2 = new Date(b.original.start_date).getTime();

        if (d1 !== d2) return d1 - d2;

        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <span className="sub-date">{value.replace("GMT","")}</span> 
    },
    { Header: "Created", accessor: "created_at", Cell: ({ value }: any) => <span className="sub-date">{value.replace("GMT","")}</span> },
    { 
      Header: "Next Payment", 
      accessor: "next_payment_date", 
      sortType: (a, b) => {
        const d1 = new Date(a.original.next_payment_date || 0).getTime();
        const d2 = new Date(b.original.next_payment_date || 0).getTime();
        if (d1 !== d2) return d1 - d2;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <span className="sub-date">{value.replace("GMT","") || "—"}</span> 
    },
    { Header: "Subscription ID", accessor: "id", Cell: ({ row }: any) => <ShortTruncateCopy info={row.original.subscription_id || "—"} showCopy /> },
    { 
      Header: "Interval", 
      accessor: "interval", 
      sortType: (a, b) => {
        const result = (a.original.interval || "").localeCompare(b.original.interval || "");
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <span className="sub-tag">{value}</span> 
    },
    { 
      Header: "Duration", 
      accessor: "duration", 
      sortType: (a, b) => {
        const result = Number(a.original.duration || 0) - Number(b.original.duration || 0);
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <span className="sub-num">{value}</span> 
    },
    {
      Header: "Amount", accessor: "amount",
      sortType: (a, b) => {
        const result = Number(a.original.amount || 0) - Number(b.original.amount || 0);
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ row }: any) => <span className="sub-amount">{convertToFloat(row.original.amount)} {row.original.currency}</span>,
    },
    { 
      Header: "Descriptor", 
      accessor: "descriptor", 
      sortType: (a, b) => {
        const result = (a.original.descriptor || "").localeCompare( b.original.descriptor || "");
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <span className="sub-descriptor">{value || "—"}</span> 
    },
    {
      Header: "Progress", accessor: "transaction",
      sortType: (a, b) => {
        const pA = (a.original.paid_payments || 0) / (a.original.billing_cycles || 1);
        const pB = (b.original.paid_payments || 0) / (b.original.billing_cycles || 1);
        return pA !== pB ? pA - pB : (a.original.billing_cycles || 0) - (b.original.billing_cycles || 0);
      },
      Cell: ({ row }: any) => (
        <div className="sub-progress-cell">
          <span className="sub-progress-text">{row.original.paid_payments}/{row.original.billing_cycles}</span>
          <div className="sub-progress-bar">
            <div
              className="sub-progress-fill"
              style={{ width: `${Math.min(100, ((row.original.paid_payments || 0) / (row.original.billing_cycles || 1)) * 100)}%` }}
            />
          </div>
        </div>
      ),
    },
    {
      Header: "Status", accessor: "status",
      sortType: (a, b) => {
        const result = (a.original.status || "").localeCompare(b.original.status || "");
        if (result !== 0) return result;
        return String(a.original.id).localeCompare(String(b.original.id));
      },
      Cell: ({ value }: any) => <StatusStyle status={value} value={value} />,
    },
    // {
    //   Header: "Actions",
    //   Cell: ({ row }: any) => (
    //     <div className="sub-actions">
    //       {roleData[0]?.subscription?.value?.view_subscription_response_information && (
    //         <InfoModalSubscription info={row?.original} />
    //       )}
    //       {roleData[0]?.subscription?.value?.cancel_subscription && (
    //         <Popover trigger="hover" placement="bottom" >
    //           <PopoverTrigger>
    //             <span className="inline-flex">
    //               {row.original.status === 'ACTIVE' ? (
    //                 <button
    //                   className="sub-cancel-btn"
    //                   onClick={() => openCancelPanel(row.original)}
    //                   aria-label="Cancel subscription"
    //                 >
    //                   <BsXCircleFill size={14} />
    //                 </button>
    //               ) : (
    //                 <button className="sub-cancel-btn sub-cancel-btn--disabled" disabled aria-label="Cannot cancel">
    //                   <BsXCircleFill size={14} />
    //                 </button>
    //               )}
    //             </span>
    //           </PopoverTrigger>
    //           <PopoverContent border="1px solid #fecaca" borderRadius="12px" bg="#fff1f2" maxW="180px" p="0" overflow="hidden" zIndex="20">
    //             <PopoverHeader bg="#ffe4e6" fontSize="12px" fontWeight="700" color="#b91c1c" borderBottom="1px solid #fecaca" px="12px" py="9px">
    //               Cancel Subscription
    //             </PopoverHeader>
    //             <PopoverArrow bg="#fff1f2" />
    //           </PopoverContent>
    //         </Popover>
    //       )}
    //     </div>
    //   ),
    //   disableSortBy: true,
    // },
    ...(canCancelSubscription || canViewSubscriptionInfo ? [
          {
            Header: "Actions",

            Cell: ({ row }: any) => (
              <div className="sub-actions">

                {canViewSubscriptionInfo  && (
                  <InfoModalSubscription
                    info={row?.original}
                  />
                )}

                {canCancelSubscription  && (
                  <Popover
                    trigger="hover"
                    placement="bottom"
                  >
                    <PopoverTrigger>
                      <span className="inline-flex">

                        {row.original.status ===
                        "ACTIVE" ? (
                          <button
                            className="sub-cancel-btn"
                            onClick={() =>
                              openCancelPanel(
                                row.original
                              )
                            }
                            aria-label="Cancel subscription"
                          >
                            <BsXCircleFill size={14} />
                          </button>
                        ) : (
                          <button
                            className="sub-cancel-btn sub-cancel-btn--disabled"
                            disabled
                            aria-label="Cannot cancel"
                          >
                            <BsXCircleFill size={14} />
                          </button>
                        )}

                      </span>
                    </PopoverTrigger>

                    <PopoverContent
                      border="1px solid #fecaca"
                      borderRadius="12px"
                      bg="#fff1f2"
                      maxW="180px"
                      p="0"
                      overflow="hidden"
                      zIndex="20"
                    >
                      <PopoverHeader
                        bg="#ffe4e6"
                        fontSize="12px"
                        fontWeight="700"
                        color="#b91c1c"
                        borderBottom="1px solid #fecaca"
                        px="12px"
                        py="9px"
                      >
                        Cancel Subscription
                      </PopoverHeader>

                      <PopoverArrow bg="#fff1f2" />
                    </PopoverContent>
                  </Popover>
                )}
              </div>
            ),

            disableSortBy: true,
          } as Column<SubscriptionObj>,
        ]
      : []
  ),
  ], [expandedRows, roleData, openCancelPanel]);

  const dataWithExpandedContent = useMemo(
    () => data.map((row) => ({ ...row, subRows: row.payment.map((p: any) => ({ ...p })) })),
    [data]
  );
 
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    { columns, data: dataWithExpandedContent },
    useSortBy, useExpanded
  );

  const handleValueChange = (e: any) => { setExpandedRows({}); onValueChange(e); };

  const handelOnDownloadCSV = () => {
    setDownloadLoading(true);
    const clients = filter?.clients?.map((m: any) => m.value);
    const interval = filter?.interval?.map((m: any) => m.value);
    DownloadCSV(clients, interval, filter?.duration, filter?.status?.map((m: any) => m.value),searchTexts)
      .then((response) => {
        const blob = new Blob([response], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "subscriptions.csv";
        document.body.appendChild(link); link.click(); document.body.removeChild(link);
        toast.success("Download completed");
        setDownloadLoading(false);
      })
      .catch(() => { toast.error("Download failed"); setDownloadLoading(false); });
  };

  const getSubClientsData = () => {
    subscriptionGetClients()
      .then((response: any) => setSubClientsData(response?.map((m: any) => ({ label: m, value: m }))))
      .catch(() => {});
  };

  useEffect(() => { getSubClientsData(); }, []);
  useEffect(() => { setExpandedRows({}); }, [page, pageSize]);
  const filterDataApplied = () => setExpandedRows({});

  /* ─── Sub-table header labels ─── */
  const subHeaders = [
    "Client", "Date", "Amount", "Transaction ID", "Internal ID",
    method ? "Gateway Name" : "Gateway Hash ID",
    "Descriptor", "Card", "Status",
  ];
  const hasSubscriptionActions = roleData?.[0]?.subscription?.value?.cancel_subscription ||
    roleData?.[0]?.subscription?.value?.view_subscription_gateway_response_information ||
    roleData?.[0]?.subscription?.value?.view_subscription_response_information;

  const hasPaymentActions = roleData?.[0]?.payment?.value?.view_payment_receipt ||
    roleData?.[0]?.payment?.value?.retry_payment_list ||
    roleData?.[0]?.payment?.value?.view_payment_response_information ||
    roleData?.[0]?.payment?.value?.view_gateway_response_information ||
    roleData?.[0]?.payment?.value?.refund_payment_list;


  return (
    <div className="sub-card">
      {/* ── Cancel Subscription Panel ── */}
      <CancelSubscriptionPanel
        isOpen={cancelPanelOpen}
        onClose={() => { setCancelPanelOpen(false); setCancelTarget(null); }}
        onConfirm={handleCancelConfirm}
        isLoading={cancelPanelLoading}
        subscriptionId={cancelTarget?.subscriptionId}
        clientName={cancelTarget?.clientName}
        amount={cancelTarget?.amount}
        currency={cancelTarget?.currency}
        interval={cancelTarget?.interval}
      />

      {/* ── Header ── */}
      <div className="sub-header">
        <div className="sub-header-left">
          <div className="sub-header-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>
            </svg>
          </div>
          <div>
            <h3 className="sub-title">All Subscriptions</h3>
            <p className="sub-subtitle">{props.totalItems > 0 ? `${props.totalItems} subscription${props.totalItems !== 1 ? "s" : ""}` : "No subscriptions"}</p>
          </div>
        </div>
        <div className="sub-header-right">
          <button className="sub-download-btn" onClick={handelOnDownloadCSV} disabled={DownloadLoading || rows.length === 0}>
            {DownloadLoading ? <span className="sub-btn-spinner" /> : <FaDownload size={12} />}
            Export CSV
          </button>
          <FilterModal
            subClientsData={subClientsData} setPage={props.setPage}
            filter={filter} setFilter={setFilter} roleData={roleData}
            setClearClick={setClearClick} filterData={filterData}
            fetchSubscriptions={fetchSubscriptions} filterDataApplied={filterDataApplied} setPageSize={setPageSize}
          />
          <Searchbox onSearch={handleValueChange} />
        </div>
      </div>

      {/* ── Table ── */}
      <div className="sub-table-wrap">
        {props.isLoading ? (
          <div className="sub-loading-state">
            <div className="sub-spinner" />
            <p className="sub-loading-txt">Loading subscriptions…</p>
          </div>
        ) : (
          <table {...getTableProps()} className="sub-table">
            <thead>
              {headerGroups.map((hg, i) => (
                <tr key={i}>
                  {hg.headers.map((col: any, ci) => (
                    <th
                      key={ci}
                      {...col.getHeaderProps(col.getSortByToggleProps())}
                      className={`sub-thead-th${col.disableSortBy ? "" : " sub-thead-th--sort"}`}
                    >
                      <div className="sub-th-inner">
                        <span className="sub-th">{col.render("Header")}</span>
                        {!col.disableSortBy && (
                          <span className="sub-sort-icon">
                            {col.isSorted ? (col.isSortedDesc ? <BsArrowDown size={11} /> : <BsArrowUp size={11} />) : <RiArrowUpDownFill size={11} />}
                          </span>
                        )}
                      </div>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.length > 0 ? (
                rows.map((row: Row<SubscriptionObj>, ri) => {
                  prepareRow(row);
                  return (
                    <React.Fragment key={row.id}>
                      <tr {...row.getRowProps()} className={`sub-tbody-tr${ri % 2 !== 0 ? " sub-tbody-tr--alt" : ""}`}>
                        {row.cells.map((cell: any, ci) => (
                          <td key={ci} {...cell.getCellProps()} className="sub-tbody-td">
                            {cell.column.id === "amount"
                              ? <span className="sub-amount">{convertToFloat(cell.value)} {row.original.currency}</span>
                              : cell.column.id === "status"
                              ? <StatusStyle status={cell.value} value={cell.value} />
                              : cell.column.id === "id"
                              ? <ShortTruncateCopy info={row.original.subscription_id || "—"} showCopy />
                              : cell.render("Cell")}
                          </td>
                        ))}
                      </tr>

                      {/* ── Expanded sub-table ── */}
                      {expandedRows[row.id] && (
                        <tr className="sub-expanded-row">
                          <td colSpan={columns.length} className="sub-expanded-cell">
                            <div className="sub-subtable-wrap">
                              <table className="sub-subtable">
                                <thead>
                                  <tr>
                                    {[...subHeaders, ...(hasPaymentActions ? ["Actions"] : [])].map((h) => (
                                      <th key={h} className="sub-subtable-th"><span className="sub-subtable-th-label">{h}</span></th>
                                    ))}
                                  </tr>
                                </thead>
                                <tbody>
                                  {row?.original?.payment?.map((payment: any, idx: number) => {
                                    const enRefund = allGateways.find((g: any) => g?.id === payment?.gateway_id);
                                    return (
                                      <tr key={idx} className="sub-subtable-tr">
                                        <td className="sub-subtable-td">
                                          <div className="sub-client-cell">
                                            <div className="sub-client-avatar sub-client-avatar--sm">{payment.client?.charAt(0)?.toUpperCase() || "?"}</div>
                                            <span className="sub-client-name">{payment.client}</span>
                                          </div>
                                        </td>
                                        <td className="sub-subtable-td"><span className="sub-date">{payment.created_at.replace("GMT","")}</span></td>
                                        <td className="sub-subtable-td">
                                          <div className="sub-amount-cell">
                                            <span className="sub-amount">{convertToFloat(payment.amount)} {payment.currency}</span>
                                            {payment?.converted_amount && payment?.converted_currency && (
                                              <span className="sub-amount-conv">({payment.converted_amount} {payment.converted_currency})</span>
                                            )}
                                          </div>
                                        </td>
                                        <td className="sub-subtable-td"><ShortTruncateCopy info={payment?.et_id || "—"} showCopy /></td>
                                        <td className="sub-subtable-td"><ShortTruncateCopy info={payment?.id || "—"} showCopy /></td>
                                        <td className="sub-subtable-td">
                                          {!method
                                            ? <ShortTruncateCopy info={payment?.gateway_id || "—"} showCopy />
                                            : <div className="sub-gateway-cell"><img style={{ height: "auto", width: "14px" }} src={getImage(payment?.gateway_name)} alt={payment?.gateway_name} /><span className="sub-gateway-name">{payment?.gateway_name || "—"}</span></div>}
                                        </td>
                                        <td className="sub-subtable-td"><span className="sub-descriptor">{payment.gateway_name}</span></td>
                                        <td className="sub-subtable-td">{getCardSVG(payment.meta_info?.binInformation?.card_type)}</td>
                                        <td className="sub-subtable-td"><StatusRender status={payment.status} value={payment.status} /></td>
                                        {hasPaymentActions && (
                                          <td className="sub-subtable-td">
                                            <div className="sub-actions">
                                              {roleData?.[0]?.payment?.value?.refund_payment_list && (
                                                <RefundModal info={payment} transactionID={payment?.id} fetchPayments={fetchSubscriptions} enRefund={enRefund?.refund} />
                                              )}
                                              {(roleData?.[0]?.payment?.value?.view_payment_response_information || roleData?.[0]?.payment?.value?.view_gateway_response_information) && (
                                                <InfoModal info={payment} />
                                              )}
                                              {roleData?.[0]?.payment?.value?.view_payment_receipt && (
                                                <Popover trigger="hover" placement="bottom">
                                                  <PopoverTrigger>
                                                    <a href={payment?.receipt_url} target="_blank" aria-disabled={!payment?.receipt_url} className="txn-action-btn aria-disabled:opacity-40" onClick={(e: any) => e.currentTarget.blur()}>
                                                      <BsReceipt size={12} />
                                                    </a>
                                                  </PopoverTrigger>
                                                  <PopoverContent border="1px solid #bfdbfe" borderRadius="12px" bg="#eff6ff" maxW="190px" p="0" overflow="hidden" zIndex="20">
                                                    <PopoverHeader bg="#dbeafe" fontSize="12px" fontWeight="700" color="#1e40af" borderBottom="1px solid #bfdbfe" px="12px" py="9px">View Receipt</PopoverHeader>
                                                    <PopoverArrow bg="#eff6ff" />
                                                  </PopoverContent>
                                                </Popover>
                                              )}
                                              {roleData?.[0]?.payment?.value?.retry_payment_list && (
                                                <RetryModal info={payment} transactionID={payment?.id} fetchPayments={fetchSubscriptions} enRefund={enRefund?.refund} />
                                              )}
                                            </div>
                                          </td>
                                        )}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr><td colSpan={15}>
                  <div className="sub-empty">
                    <div className="sub-empty-icon">
                      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
                      </svg>
                    </div>
                    <p className="sub-empty-title">No subscriptions found</p>
                    <p className="sub-empty-sub">Try adjusting your filters</p>
                  </div>
                </td></tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* ── Pagination ── */}
      <div className="sub-pagination-wrap">
        <Pagination setPage={setPage} page={page} totalpage={totalpage} currentPage={currentPage} pageSize={pageSize} setPageSize={setPageSize} arraySize={[50, 100, 200]} />
      </div>

      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

        .sub-card { font-family:'Plus Jakarta Sans',sans-serif; background:#fff; border:1px solid #e2e8f0; border-radius:18px; overflow:hidden; box-shadow:0 2px 8px rgba(15,23,42,.06); }

        /* Header */
        .sub-header { padding:16px 20px 13px; border-bottom:1px solid #f1f5f9; display:flex; align-items:center; justify-content:space-between; gap:12px; flex-wrap:wrap; }
        .sub-header-left { display:flex; align-items:center; gap:10px; }
        .sub-header-icon { width:38px; height:38px; border-radius:10px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; color:#2563eb; flex-shrink:0; }
        .sub-title { font-size:14px; font-weight:700; color:#0f172a; letter-spacing:-0.2px; margin-bottom:1px; line-height:20px; }
        .sub-subtitle { font-size:11.5px; color:#94a3b8; font-weight:500; }
        .sub-header-right { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }

        .sub-download-btn { display:inline-flex; align-items:center; gap:5px; font-family:'Plus Jakarta Sans',sans-serif; font-size:12px; font-weight:700; color:#fff; padding:10px 13px; border-radius:9px; border:none; background:linear-gradient(135deg,#1d4ed8,#2563eb); cursor:pointer; box-shadow:0 2px 8px rgba(37,99,235,.22); transition:all .15s; white-space:nowrap; }
        .sub-download-btn:hover:not(:disabled) { transform:translateY(-1px); }
        .sub-download-btn:disabled { opacity:.5; cursor:not-allowed; }
        .sub-btn-spinner { width:12px; height:12px; border:2px solid rgba(255,255,255,.35); border-top-color:#fff; border-radius:50%; animation:subSpin .65s linear infinite; }
        @keyframes subSpin { to{transform:rotate(360deg)} }

        /* Table */
        .sub-table-wrap { overflow-x:auto; }
        .sub-table-wrap::-webkit-scrollbar { height:3px; }
        .sub-table-wrap::-webkit-scrollbar-thumb { background:#cbd5e1; border-radius:4px; }
        .sub-table { width:100%; border-collapse:collapse; }

        .sub-thead-th { padding:9px 12px 8px; background:#f8fafc; border-bottom:1.5px solid #e2e8f0; text-align:left; white-space:nowrap; user-select:none; }
        .sub-thead-th--sort { cursor:pointer; }
        .sub-thead-th--sort:hover { background:#f1f5f9; }
        .sub-th-inner { display:flex; align-items:center; gap:4px; }
        .sub-th { font-size:10.5px; font-weight:700; color:#374151; text-transform:uppercase; letter-spacing:0.4px; }
        .sub-sort-icon { color:#b0bec5; display:flex; align-items:center; flex-shrink:0; }
        .sub-thead-th--sort:hover .sub-sort-icon { color:#2563eb; }

        .sub-tbody-tr { transition:background .1s; }
        .sub-tbody-tr:hover { background:#f8faff; }
        .sub-tbody-tr--alt { background:#fafbfc; }
        .sub-tbody-tr--alt:hover { background:#f1f5f9; }
        .sub-tbody-td { padding:8px 12px; border-bottom:1px solid #f1f5f9; vertical-align:middle; }

        /* Expand button */
        .sub-expand-btn { width:26px; height:26px; border-radius:7px; background:#eff6ff; border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; cursor:pointer; transition:all .15s; }
        .sub-expand-btn:hover { background:#dbeafe; }
        .sub-expand-icon { width:16px; height:16px; color:#2563eb; }

        /* Cell helpers */
        .sub-client-cell { display:flex; align-items:center; gap:6px; }
        .sub-client-avatar { width:24px; height:24px; border-radius:6px; background:linear-gradient(135deg,#eff6ff,#dbeafe); border:1.5px solid #bfdbfe; display:flex; align-items:center; justify-content:center; font-size:9.5px; font-weight:800; color:#2563eb; flex-shrink:0; }
        .sub-client-avatar--sm { width:20px; height:20px; font-size:9px; }
        .sub-client-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
        .sub-gateway-cell { display:flex; align-items:center; gap:6px; }
        .sub-gateway-name { font-size:12px; font-weight:600; color:#0f172a; white-space:nowrap; }
        .sub-date { font-size:11.5px; font-weight:500; color:#334155; white-space:nowrap; }
        .sub-amount-cell { display:flex; flex-direction:column; gap:1px; }
        .sub-amount { font-size:12.5px; font-weight:700; color:#0f172a; white-space:nowrap; text-transform:uppercase; }
        .sub-amount-conv { font-size:10.5px; color:#94a3b8; font-weight:500; }
        .sub-descriptor { font-size:12px; font-weight:500; color:#475569; white-space:nowrap; }
        .sub-tag { display:inline-block; padding:3px 9px; border-radius:7px; font-size:11px; font-weight:700; background:#f0f9ff; border:1.5px solid #bae6fd; color:#0284c7; text-transform:uppercase; white-space:nowrap; }
        .sub-num { font-size:12.5px; font-weight:700; color:#0f172a; }
        .sub-muted { font-size:12px; color:#cbd5e1; }
        .sub-progress-cell { display:flex; flex-direction:column; gap:4px; }
        .sub-progress-text { font-size:11.5px; font-weight:700; color:#0f172a; }
        .sub-progress-bar { height:4px; background:#e2e8f0; border-radius:4px; overflow:hidden; min-width:60px; }
        .sub-progress-fill { height:100%; background:linear-gradient(90deg,#2563eb,#7c3aed); border-radius:4px; transition:width .3s; }
        .sub-actions { display:flex; align-items:center; gap:4px; }
        .sub-cancel-btn { width:26px; height:26px; border-radius:7px; background:#fff1f2; border:1.5px solid #fecdd3; color:#dc2626; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:all .15s; }
        .sub-cancel-btn:hover { background:#ffe4e6; }
        .sub-cancel-btn--disabled { opacity:.4; cursor:not-allowed; }

        /* Shared action btn from txn */
        .txn-action-btn { width:26px; height:26px; border-radius:7px; background:#f8fafc; border:1.5px solid #e2e8f0; color:#64748b; display:flex; align-items:center; justify-content:center; transition:all .15s; text-decoration:none; cursor:pointer; }
        .txn-action-btn:hover { background:#eff6ff; border-color:#bfdbfe; color:#2563eb; }

        /* Expanded sub-table */
        .sub-expanded-row { }
        .sub-expanded-cell { padding:0 !important; border-bottom:2px solid #e2e8f0; }
        .sub-subtable-wrap { background:#f0f7ff; overflow-x:auto; border-left:3px solid #bfdbfe; }
        .sub-subtable { width:100%; border-collapse:collapse; }
        .sub-subtable-th { padding:8px 12px 6px; background:#e0f0ff; border-bottom:1.5px solid #bfdbfe; text-align:left; white-space:nowrap; }
        .sub-subtable-th-label { font-size:10px; font-weight:700; color:#1e3a8a; text-transform:uppercase; letter-spacing:0.4px; }
        .sub-subtable-tr { transition:background .1s; }
        .sub-subtable-tr:hover { background:#dbeafe; }
        .sub-subtable-td { padding:7px 12px; border-bottom:1px solid #dbeafe; vertical-align:middle; }

        /* States */
        .sub-loading-state { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px; gap:12px; }
        .sub-spinner { width:26px; height:26px; border:3px solid #e2e8f0; border-top-color:#2563eb; border-radius:50%; animation:subSpin .7s linear infinite; }
        .sub-loading-txt { font-size:12.5px; color:#94a3b8; font-weight:500; }
        .sub-empty { display:flex; flex-direction:column; align-items:center; justify-content:center; padding:48px 24px; gap:10px; }
        .sub-empty-icon { width:48px; height:48px; border-radius:12px; background:#f8fafc; border:1.5px solid #e2e8f0; display:flex; align-items:center; justify-content:center; color:#cbd5e1; }
        .sub-empty-title { font-size:13.5px; font-weight:700; color:#64748b; }
        .sub-empty-sub { font-size:12px; color:#94a3b8; font-weight:500; text-align:center; }
        .sub-pagination-wrap { padding:10px 14px; border-top:1px solid #f1f5f9; background:#fafbfc; }

        @media (max-width:700px) { .sub-header { flex-direction:column; align-items:flex-start; } .sub-header-right { width:100%; } }
      `}</style>
    </div>
  );
}

export default SubscriptionList;